import { Button } from '@heroui/react';

import { DISCARDED } from '../../i18n/el';

// **P1-5β: τι ακριβώς πετάχτηκε στην προσάρτηση.**
//
// ⚠ **Το πρόβλημα ήταν η ΣΙΩΠΗ, όχι η απόρριψη.** Η απόφαση **D9** είναι σωστή και
// δεν αλλάζει: ο ένας πελάτης δεν ξαναγράφει την επιμέλεια του άλλου επειδή έτυχε
// να καταχωρήσει δεύτερος. Αυτό που έλειπε ήταν να **το μάθει ο χρήστης**: ό,τι
// πληκτρολόγησε δεν αποθηκευόταν, δεν εμφανιζόταν, δεν ανακτούνταν πουθενά.
// Σιωπηλή απόρριψη εισόδου είναι ακριβώς η ΜΛΑ-03.
//
// **Τι κάνει και τι ΔΕΝ κάνει:**
//
// - Δείχνει **πεδίο προς πεδίο** τι έστειλε ο χρήστης δίπλα στην τιμή που ισχύει.
// - Το κουμπί **γεμίζει φόρμα**, δεν αποθηκεύει. Την αποθήκευση την πατά ο
//   άνθρωπος, με τα δικαιώματά του και με το ίχνος του.
// - **Δεν κρίνει ποια τιμή είναι καλύτερη.** Το ερώτημα τίθεται σε άνθρωπο που
//   βλέπει και τις δύο — το όριο του §3.6.
//
// *Απορρίφθηκαν ρητά:* τα απορριφθέντα να γίνονται **σχόλιο** (το σχόλιο είναι
// ανθρώπινη κρίση· μηχανικά αντλημένος τίτλος σελίδας δεν είναι κρίση κανενός) ή
// **καθήκον** (ίδιο πρόβλημα, και η ροή δραστηριότητας θα γέμιζε αυτόματα
// παραγόμενο περιεχόμενο).

export default function DiscardedCuration({ discarded = [], onForward = null }) {
    if (discarded.length === 0) return null;

    return (
        <div className="mt-3 flex flex-col gap-2 rounded-lg border border-border bg-surface p-3">
            <p className="text-sm font-semibold">{DISCARDED.title}</p>
            <p className="text-xs text-muted">{DISCARDED.intro}</p>

            {/* Ο πίνακας κυλά **μέσα στο δικό του πλαίσιο** και δεν σπρώχνει τη
                σελίδα οριζόντια: ένα μακρύ κείμενο σε στενή οθόνη θα έκανε
                ολόκληρο το μήνυμα να ξεχειλίσει. */}
            <div className="overflow-x-auto">
                <table className="w-full min-w-80 text-left text-sm">
                    <thead>
                        <tr className="text-xs text-muted">
                            <th scope="col" className="py-1 pe-3 font-medium">&nbsp;</th>
                            <th scope="col" className="py-1 pe-3 font-medium">{DISCARDED.yours}</th>
                            <th scope="col" className="py-1 font-medium">{DISCARDED.current}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {discarded.map((entry) => (
                            <tr key={entry.field} className="border-t border-border align-top">
                                <th scope="row" className="py-1.5 pe-3 font-medium">
                                    {/* Πεδίο χωρίς ελληνικό όνομα εμφανίζεται με το
                                        αναγνωριστικό του — ορατό, άσχημο, και
                                        πιασμένο από δοκιμή πληρότητας. */}
                                    {DISCARDED.labels[entry.field] ?? entry.field}
                                </th>
                                <td className="py-1.5 pe-3 break-words">{entry.submitted}</td>
                                <td className="py-1.5 break-words text-muted">
                                    {entry.current === '' ? DISCARDED.none : entry.current}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {onForward && (
                <div className="flex flex-col gap-1">
                    <Button size="sm" variant="outline" className="self-start" onPress={onForward}>
                        <i className="fa-solid fa-pen-to-square" aria-hidden="true" />
                        {DISCARDED.forward}
                    </Button>
                    <p className="text-xs text-muted">{DISCARDED.forwardHint}</p>
                </div>
            )}
        </div>
    );
}
